import React, { useContext, useEffect, useState } from "react";
import styles from "./InstaGramParticipatePopup.module.css";
import emailIcon from "../../assests/emailIcon.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";
import singinCloseButton from "../../assests/singinCloseButton.svg";
import success from "../../assests/share/copySuccessRound.svg";
import Context from "../../context/Context";

const InstaGramParticipatePopup = ({ setPopup }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { details } = useContext(Context);
  let defaultMessage =
    "<ul>\n<li>Go to https://goviralit.com</li>\n<li>Click Campaigns from menu</li>\n<li>Choose respective campign from the list and upload your entry!</li>\n<li>Or Sign in using email and password</li>\n</ul>\n";

  return (
    <div className={styles.mainDiv}>
      <div className={styles.container}>
        <div className="w-[100%] flex justify-end p-[10px] cursor-pointer">
          <img
            src={singinCloseButton}
            onClick={() => {
              setPopup(false);
            }}
          />
        </div>
        <h3 className="text-regular-bold  mb-[14px]">Sign in with Google</h3>

        <p className="text-small mb-[25px]">
          Instagram/Facebook doesn’t allow to login with Gmail when coming
          direct from the app . Please follow below steps for Gmail login
        </p>
        <h3 className="text-regular-medium mb-[14px]">How To Participate</h3>
        <div
          className="text-left text-small text-opacity-80 mb-[25px]"
          dangerouslySetInnerHTML={{
            __html: `${details?.instagramParticipateText || defaultMessage}`,
          }}
        />
      </div>
    </div>
  );
};

export default InstaGramParticipatePopup;
